import React from "react";
import {
  Grid,
  Table,
  TableHead,
  TableRow,
  TableCell,
  Typography,
  TableBody,
  TableContainer,
  Paper,
  Box,
  useTheme,
  useMediaQuery,
} from "@mui/material";

const getNestedValue = (obj, path) => {
  return path
    .split(".")
    .reduce((acc, key) => (acc && acc[key] !== undefined ? acc[key] : ""), obj);
};

const DataTable = ({ columns = [], data = [] }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  return (
    <Grid width="100%">
      {isMobile ? (

        <Box>
          {data?.map((item, index) => (
            <Paper
              key={index}
              sx={{
                mb: 1,
                p: 2,
                borderRadius: "10px",
                border: "1px solid lightgray",
              }}
            >
              <Typography fontWeight="bold" fontSize={12} mb={1}>
                Sl No: {index + 1}
              </Typography>
              {columns?.map((column, colIndex) => (
                <Box
                  key={colIndex}
                  sx={{
                    display: "flex",
                    justifyContent: "space-between",
                    borderTop: "1px solid #eee",
                    py: 0.5,
                  }}
                >
                  <Typography fontWeight="bold" fontSize={12}>
                    {column.header}
                  </Typography>
                  <Typography fontSize={12}>
                    {getNestedValue(item, column.key)}
                  </Typography>
                </Box>
              ))}
            </Paper>
          ))}
        </Box>
      ) : (

        <TableContainer
          sx={{
            borderRadius: "10px",
            border: "1px solid lightgray",
            backgroundColor: "#FFF",
            minHeight: 455
          }}
        >
          <Table size="small">
            <TableHead>
              <TableRow>
                <TableCell key="slno">
                  <Typography fontWeight="bold" fontSize={12}>
                    Sl No
                  </Typography>
                </TableCell>
                {columns?.map((column, index) => (
                  <TableCell key={index}>
                    <Typography
                      fontWeight="bold"
                      fontSize={12}
                      textAlign={column.header === "Action" ? "center" : ""}
                    >
                      {column.header}
                    </Typography>
                  </TableCell>
                ))}
              </TableRow>
            </TableHead>
            <TableBody>
              {data?.map((item, rowIndex) => (
                <TableRow
                  hover
                  key={rowIndex}
                  sx={{
                    backgroundColor:
                      rowIndex % 2 === 0 ? "lightgray" : "#ffffff",
                  }}
                >
                  <TableCell>
                    <Typography fontSize={12}>{rowIndex + 1}</Typography>
                  </TableCell>
                  {columns?.map((column, colIndex) => (
                    <TableCell key={`${rowIndex}-${colIndex}`}>
                      <Typography fontSize={12}>
                        {getNestedValue(item, column.key)}
                      </Typography>
                    </TableCell>
                  ))}
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
      )}
    </Grid>
  );
};

export default DataTable;
